/**
 * wedding-packages.js
 */
'use strict';

/* ============================================================
   SCROLL ANIMATIONS
   ============================================================ */
function initScrollAnimations() {
  const elements = document.querySelectorAll('.wp-animate');
  if (!elements.length) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('wp-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

  elements.forEach((el) => {
    if (el.closest('.wp-hero')) {
      setTimeout(() => el.classList.add('wp-visible'), 100);
    } else {
      observer.observe(el);
    }
  });
}

/* ============================================================
   HERO PARALLAX
   ============================================================ */
function initHeroParallax() {
  const hero = document.querySelector('.wp-hero');
  if (!hero) return;

  let ticking = false;

  window.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(() => {
        const scrolled = window.scrollY;
        if (scrolled < window.innerHeight * 1.2) {
          hero.style.backgroundPositionY = `calc(50% + ${scrolled * 0.28}px)`;
        }
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });
}

/* ============================================================
   IMAGE UPLOAD PREVIEWS
   ============================================================ */
function initImagePreviews() {
  const slots = [
    { inputId: 'wf_img1', previewId: 'wf_preview1', labelId: 'wf_img1_label' },
    { inputId: 'wf_img2', previewId: 'wf_preview2', labelId: 'wf_img2_label' },
    { inputId: 'wf_img3', previewId: 'wf_preview3', labelId: 'wf_img3_label' },
  ];

  slots.forEach(({ inputId, previewId, labelId }) => {
    const input   = document.getElementById(inputId);
    const preview = document.getElementById(previewId);
    const label   = document.getElementById(labelId);

    if (!input || !preview || !label) return;

    input.addEventListener('change', () => {
      const file = input.files[0];
      if (!file) return;

      if (!file.type.startsWith('image/')) {
        alert('Please upload an image file.');
        return;
      }

      const reader = new FileReader();
      reader.onload = (ev) => {
        preview.style.display = 'block';
        preview.innerHTML = `<img src="${ev.target.result}" alt="Preview" style="width:100%; height:100%; object-fit:cover; border-radius:4px;">`;

        label.style.opacity = '0.4';

        const textEl = label.querySelector('.wp-upload-text');
        if (textEl) {
          textEl.textContent =
            file.name.length > 10 ? file.name.slice(0, 8) + '...' : file.name;
        }

        label.style.borderColor = '#144987';
      };

      reader.readAsDataURL(file);
    });
  });
}

/* ============================================================
   SELECT FLOATING LABELS
   ============================================================ */
function initSelectLabels() {
  document.querySelectorAll('.wp-field select').forEach((select) => {
    const field = select.closest('.wp-field');
    if (!field) return;

    const update = () =>
      field.classList.toggle('has-value', select.value !== '');

    select.addEventListener('change', update);
    update();
  });
}

/* ============================================================
   DATE FIELD FLOATING LABELS
   ============================================================ */
function initDateLabels() {
  document.querySelectorAll('.wp-field input[type="date"]').forEach((input) => {
    const field = input.closest('.wp-field');
    if (!field) return;

    input.addEventListener('change', () => {
      field.classList.toggle('has-value', input.value !== '');
    });
  });
}

/* ============================================================
   FORM
   ============================================================ */
function initForm() {
  const form = document.getElementById('WeddingInquiryForm');
  if (!form) return;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    const requiredFields = form.querySelectorAll('[required]');
    let valid = true;

    requiredFields.forEach((input) => {
      const isEmpty =
        input.type === 'file'
          ? input.files.length === 0
          : !input.value.trim();

      const container =
        input.closest('.wp-upload-slot') || input.closest('.wp-field');

      if (isEmpty) {
        valid = false;
        if (container) container.classList.add('wp-field--error');
      } else {
        if (container) container.classList.remove('wp-field--error');
      }
    });

    if (!valid) {
      const firstError = form.querySelector('.wp-field--error');
      if (firstError)
        firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    const btn = form.querySelector('.wp-submit-btn');
    const btnText = btn ? btn.querySelector('.wp-btn-text') : null;
    const origText = btnText ? btnText.textContent : 'Submit Inquiry';

    if (btn) btn.disabled = true;
    if (btnText) btnText.textContent = 'Sending…';

    const formData = new FormData(form);

    const payload = {
      full_name: formData.get('full_name'),
      email: formData.get('email'),
      phone: formData.get('phone'),
      package: formData.get('package'),
      wedding_date: formData.get('wedding_date'),
      venue: formData.get('venue'),
      addons: formData.get('addons'),
      photographer: formData.get('photographer'),
      referral_source: formData.get('referral_source'),
      inspiration_image_1: formData.get('inspiration_image_1'),
      inspiration_image_2: formData.get('inspiration_image_2'),
      inspiration_image_3: formData.get('inspiration_image_3'),
    };

    console.log('[Wedding Inquiry] Payload ready:', payload);

    try {
      const response = await fetch('/apps/wedding-inquiry', {
        method: 'POST',
        body: formData
      });

      const result = await response.json();

      if (!response.ok || !result.success) {
        throw new Error(result.error || 'Submission failed');
      }

      showSuccess(form, btn, btnText, origText);

    } catch (error) {
      console.error(error);
      alert('Something went wrong. Please try again.');

      if (btn) btn.disabled = false;
      if (btnText) btnText.textContent = origText;
    }
  });
}

function showSuccess(form, btn, btnText, origText) {
  const grid = form.querySelector('.wp-form-grid');
  if (grid) grid.style.display = 'none';

  const successEl = document.getElementById('wp-form-success');
  if (successEl) successEl.classList.add('wp-success-visible');

  if (btn) btn.disabled = false;
  if (btnText) btnText.textContent = origText;
}

/* ============================================================
   SMOOTH SCROLL
   ============================================================ */
function initSmoothScroll() {
  document.querySelectorAll('a[href^="#wp-"]').forEach((anchor) => {
    anchor.addEventListener('click', (e) => {
      const target = document.querySelector(anchor.getAttribute('href'));
      if (!target) return;

      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
}

/* ============================================================
   INIT
   ============================================================ */
document.addEventListener('DOMContentLoaded', () => {
  initScrollAnimations();
  initHeroParallax();
  initImagePreviews();
  initSelectLabels();
  initDateLabels();
  initForm();
  initSmoothScroll();
});